import boot from './boot.js';
import coaching from './coaching.js';
import auth from './auth.js';
import store from '@/store';

export default {
	boot,
	coaching,
	auth,
	async showContent () {
		store.dispatch('showContent');
	},
	async hideContent () {
		store.dispatch('hideContent');
	}
};



// WEBPACK FOOTER //
// ./src/mediator/index.js